import { useCallback, useEffect } from "react"
import type { ScrollAnimationOptions } from "../types"

export function useScrollAnimation({ elementId, transformFn }: ScrollAnimationOptions): void {
  const handleScroll = useCallback(() => {
    const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight)
    const element = document.getElementById(elementId)

    if (element) {
      element.style.transform = transformFn(scrollPercent)
    }
  }, [elementId, transformFn])

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [handleScroll])
}
